export * from '@dynatrace/strato-components/notifications';
